exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/**\n * @license\n * Copyright Akveo. All Rights Reserved.\n * Licensed under the MIT License. See License.txt in the project root for license information.\n */\n:host button {\n  font-size: 2rem;\n  margin: 0 auto;\n  padding: 0;\n  cursor: pointer;\n  border: none;\n  background: none; }\n  :host button:focus {\n    box-shadow: none;\n    outline: none; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /srv/staging/FitRadioAdmin2/src/app/@nebular/theme/components/search/styles/search.component.scss
// module id = ../../../../../src/app/@nebular/theme/components/search/styles/search.component.scss
// module chunks = main